module.exports = __webpack_public_path__ + "img/logo-yec.d783351e.png";